import { abc, formatter } from "../../constants";
import { kitTotal } from "../functions";
import styled from "styled-components";
import { priceItems } from "../../constants";
import { kitSizes } from "../../constants";

const KitTitle = styled.div`
  p {
    font-size: 10px !important;
    padding: 5px 0;
  }
`;

const Category = styled.div`
  border-left: 2px dotted #ededed;
  border-bottom: 1px solid #ededed;
  border-radius: 3px;
  margin-bottom: 5px;
`;

const CategoryTitle = styled.div`
  color: lightgrey;
  font-weight: 900;
  text-transform: uppercase;
  padding: 3px 1px;
  width: max-content;
  border-radius: 3px;
  font-size: 10px;
`;

const SubItemList = styled.div``;

const SubItem = styled.div`
  margin-left: 10px;
  display: flex;
  justify-content: space-between;
  padding: 3px 0px;
  font-size: 10px;
  font-weight: 700;
  color: grey;
  border-top: 1px solid #ededed;
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  padding-left: 5px;
  font-size: 10px;
  font-weight: 700;
  color: grey;
  border-top: 1px solid #ededed;
`;

const ItemTitle = styled.div`
  text-transform: capitalize;
`;
const ItemAmount = styled.div``;

const Total = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 3px;
  padding: 5px;
  text-transform: uppercase;
  font-weight: 900;
  color: white;
  font-size: 10px;
  position: relative;
  background: darkgrey;
`;

const ItemTax = styled.div`
  color: grey;
  font-size: 8px;
`;

const PreviewKit = ({ kitsAmount, kit, i, color }) => {
  return (
    <div>
      <KitTitle style={{ display: kitsAmount > 1 ? "" : "none" }}>
        <p>
          <i>Kit {abc[i]}</i>
        </p>
      </KitTitle>

      {kit.items.map((item, k) =>
        typeof item.category === "undefined" ? (
          <div key={"preview-item" + k}>
            {!item.fundsReceived && (
              <Item>
                <ItemTitle>
                  {item.title === "package" &&
                    kit.size + " " + kitSizes[kit.size] + ","}{" "}
                  {item.title in priceItems
                    ? priceItems[item.title]
                    : item.title}
                </ItemTitle>
                <ItemAmount>{formatter.format(item.amount)}</ItemAmount>
              </Item>
            )}
          </div>
        ) : (
          <Category key={"category" + k}>
            <CategoryTitle>{item.title}</CategoryTitle>
            <SubItemList>
              {item.category.map((subItem, j) => (
                <SubItem key={`subItem${j}`}>
                  <ItemTitle>
                    {subItem.title in priceItems
                      ? priceItems[subItem.title]
                      : subItem.title}
                  </ItemTitle>
                  <ItemTax>{subItem.tax ? "" : "*tax exempt"}</ItemTax>
                  <ItemAmount>{formatter.format(subItem.amount)}</ItemAmount>
                </SubItem>
              ))}
            </SubItemList>
          </Category>
        )
      )}
      {kitsAmount > 1 && (
        <Total>
          <div>Total</div>
          <div>{formatter.format(kitTotal(kit.items))}</div>
        </Total>
      )}
    </div>
  );
};

export default PreviewKit;
